import { DateTypes, SlugDate } from '../datetime';

export const getCookies = (): Record<string, string> => Object.fromEntries(document.cookie
  .split(';')
  .filter(v => !!v)
  .map(item => item.trim().split('=')));

export const getCookie = (key: string) => getCookies()[key];

export interface Cookie {
  value?: string;
  expires?: DateTypes;
  path?: string;
  domain?: string;
}

export type Cookies = Record<string, string | Cookie>;

export const setCookie = (key: string, value: string | Cookie) => {
  const cookie = typeof value === 'string' ? { value } : value;
  const v = cookie.value ?? '';
  delete cookie.value;
  if (cookie.expires) {
    cookie.expires = new SlugDate(cookie.expires).toUTCString();
  }
  document.cookie = `${key}=${v};${Object.entries(cookie)
    .map(([key, value]) => `${key}=${value};`)
    .join('')}`;
};

export const setCookies = (cookies: Cookies) => Object.entries(cookies)
  .forEach(([key, value]) => setCookie(key, value));

export const delCookies = (keys: string[]) => setCookies(Object.fromEntries(keys
  .map(key => [key, { expires: new Date().getTime() - 1 }])));

export const delCookie = (key: string) => delCookies([key]);

// alias

export const deleteCookies = delCookies;
export const deleteCookie = delCookie;
